import { connect } from 'react-redux';
import { getSchemaSpecsListing, setContextualSupport, unsetContextualSupport } from '../../actions';
import { GET_SCHEMA_SPEC_LISTING_REQUEST } from '../../constants/actionTypes';
import { getSchemaSpecList } from '../../reducers/selectors';

import ViewSchemaSpecs from './ViewSchemaSpecs';

const mapStateToProps = (state, ownProps) => {
  const { request } = state;
  const data = getSchemaSpecList(state);

  const isLoading = !!request[GET_SCHEMA_SPEC_LISTING_REQUEST];
  return {
    data,
    isLoading,
  };
};

export default connect(mapStateToProps, {
  getSchemaSpecsListing,
  setContextualSupport,
  unsetContextualSupport,
})(ViewSchemaSpecs);
